import LaunchIcon from '@mui/icons-material/Launch'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Tooltip from '@mui/material/Tooltip'

import { Link } from '../../../router/components/Link'
import type { HoofdleidingProject } from '../../project/types/HoofdleidingProject'

export { BalkenplanningChip }

type Props = {
  project: HoofdleidingProject
}

const BalkenplanningChip = ({ project }: Props) => {
  return (
    <Tooltip
      title={`Navigeer naar ${project.naam} (project ${project.aanvraagID})`}
    >
      <Chip
        component={Link}
        to={`/hoofdleiding/project/${project.aanvraagID}`}
        target="_blank"
        rel="noreferrer"
        clickable
        label={
          <Box
            component="span"
            sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
          >
            <Box
              component="span"
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {project.naam}
            </Box>
            <LaunchIcon fontSize="inherit" sx={{ flexShrink: 0 }} />
          </Box>
        }
        color="primary"
        size="small"
        sx={{ maxWidth: '100%' }}
      />
    </Tooltip>
  )
}
